import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { loadStorageControlsData } from '../../../common/utils/load-storage-controls-data';
import { PreferenceCategory } from '../../../types';
import { getPreferences } from '../../preferences-controls/get-preferences';
export var isThirdPartyAllowed = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(thirdParty) {
    var preferences, shouldDenyThirdParty, storageControlsData, _numToCategoryMap, thirdPartyKeys, categories, thirdPartyCategoryNumber, numToCategoryMap, thirdPartyCategory, hasPreferencesForCategoryType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return getPreferences();
        case 2:
          preferences = _context.sent;
          if (preferences) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", Promise.resolve(false));
        case 5:
          shouldDenyThirdParty = false;
          _context.next = 8;
          return loadStorageControlsData();
        case 8:
          storageControlsData = _context.sent;
          if (storageControlsData) {
            thirdPartyKeys = storageControlsData.thirdPartyKeys, categories = storageControlsData.categories;
            thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
            numToCategoryMap = (_numToCategoryMap = {}, _defineProperty(_numToCategoryMap, categories.STRICTLY_NECESSARY, PreferenceCategory.StrictlyNecessary), _defineProperty(_numToCategoryMap, categories.FUNCTIONAL, PreferenceCategory.Functional), _defineProperty(_numToCategoryMap, categories.ANALYTICS, PreferenceCategory.Analytics), _defineProperty(_numToCategoryMap, categories.MARKETING, PreferenceCategory.Marketing), _defineProperty(_numToCategoryMap, categories.UNKNOWN, PreferenceCategory.Unknown), _numToCategoryMap);
            thirdPartyCategory = thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;
            hasPreferencesForCategoryType = false;
            if (!!thirdPartyCategory) {
              hasPreferencesForCategoryType = preferences[thirdPartyCategory];
            }
            shouldDenyThirdParty = hasPreferencesForCategoryType;
          }
          return _context.abrupt("return", Promise.resolve(shouldDenyThirdParty));
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function isThirdPartyAllowed(_x) {
    return _ref.apply(this, arguments);
  };
}();